import React from "react";
import {ReactComponent as Close} from 'src/assets/close.svg';
import {ReactComponent as Branch} from 'src/assets/sns/branch.svg';
import {ReactComponent as Blog} from 'src/assets/sns/Internet.svg';
import {ReactComponent as Snslink} from 'src/assets/sns/snslink.svg';


interface AlertProps {
    title: string;
    onClose: () => void;
    onConfirm?: () => void
    brunchLink?: string;
    snsLink1?: string;
    snsLink2?: string;
    naverLink?: string;
}


const SnsModal: React.FC<AlertProps> = ({ title, onClose, onConfirm, brunchLink,
                                            snsLink1,
                                            snsLink2,
                                            naverLink}) => {

    return (
        <>
            {/* 오버레이 */}
            <div className="overlay" />

            {/* 모달 */}
            <div className="penpal-alert flex flex-col w-full max-w-md p-6">
                {/* Header */}
                <div className="flex justify-between items-center pb-2 mb-2">
                    <h2 className="text-xl font-bold text-main">{title}</h2>
                    <button className="close-button" onClick={onClose}>
                        <Close/>
                    </button>
                </div>

                {/* SNS 링크 */}
                <div className={"flex flex-col items-start gap-3"}>

                    {naverLink && (
                        <div className="flex justify-center items-center gap-3">
                            <Blog />
                            <a href={naverLink} target="_blank" rel="noopener noreferrer">
                                <span className={"font-namsan"}>{naverLink}</span>
                            </a>
                        </div>
                    )}

                    {brunchLink && (
                        <div className="flex justify-center items-center gap-3">
                                <Branch />
                            <a href={brunchLink} target="_blank" rel="noopener noreferrer">
                                <span className={"font-namsan"}>{brunchLink}</span>
                            </a>
                        </div>
                    )}

                    {snsLink1 && (
                        <div className="flex justify-center items-center gap-3">
                            <Snslink className={"w-6 h-6"} />
                            <a href={snsLink1} target="_blank" rel="noopener noreferrer">
                                <span className={"font-namsan"}>{snsLink1}</span>
                            </a>
                        </div>
                    )}


                    {snsLink2 && (
                        <div className="flex justify-center items-center gap-3">
                            <Snslink className={"w-6 h-6"} />
                            <a href={snsLink2} target="_blank" rel="noopener noreferrer">
                                <span className={"font-namsan"}>{snsLink2}</span>
                            </a>
                        </div>
                    )}

                </div>
                {/* Footer */}
                <div className="flex justify-center mt-8">
                    <button
                        onClick={() => {
                            onClose();
                        }}
                        className="bg-main hover:bg-green-400 text-white px-6 py-2 rounded-md"
                    >
                        확인
                    </button>
                </div>
            </div>
        </>
    );


}

export default SnsModal;